import { Box, Grid, Typography } from "@mui/material"
import { VerifyTick } from "src/shared"
import {
  ACCUMULATION_TEM_DATE,
  EXCHANGE_GIFT_DATE,
  GIFT_RULES_DESCRIPTION,
} from "./ultils"
import WrapContainer from "./WrapContainer"

const GiftRules = () => {
  return (
    <WrapContainer imgSrc="/assets/images/rules.png" imgAlt="rules">
      <Grid container rowGap={1} alignItems="center">
        <Typography
          fontSize={16}
          lineHeight={"21px"}
          fontFamily="Roboto Slab"
          sx={theme => ({
            [theme.breakpoints.down(600)]: {
              fontSize: 14,
              lineHeight: "18px",
            },
            "& > span": {
              fontWeight: 700,
              color: "#1FA009",
            },
          })}
          color="#999999"
          fontWeight={400}
        >
          Thời gian tích tem: <span>{ACCUMULATION_TEM_DATE}</span>
        </Typography>
        <Typography
          fontSize={16}
          lineHeight={"21px"}
          fontFamily="Roboto Slab"
          sx={theme => ({
            [theme.breakpoints.down(600)]: {
              fontSize: 14,
              lineHeight: "18px",
            },
            "& > span": {
              fontWeight: 700,
              color: "#1FA009",
            },
          })}
          color="#999999"
          fontWeight={400}
        >
          Thời gian đổi quà:: <span>{EXCHANGE_GIFT_DATE}</span>
        </Typography>
      </Grid>
      {GIFT_RULES_DESCRIPTION.map((val: string) => (
        <Box
          justifyContent="flex-start"
          alignItems="flex-start"
          display="flex"
          rowGap={3}
          fontFamily="Roboto Slab"
          key={val}
          fontSize={16}
          columnGap={2}
          lineHeight="21px"
          sx={theme => ({
            [theme.breakpoints.down(600)]: {
              fontSize: 14,
              lineHeight: "18px",
            },
          })}
        >
          <Box
            flexWrap="nowrap"
            flex="0 0 auto"
            color="#1FA009"
            fontWeight={700}
          >
            <VerifyTick />
          </Box>
          <Box
            sx={{
              fontWeight: 400,
              color: "#999999",
            }}
          >
            {val}
          </Box>
        </Box>
      ))}
    </WrapContainer>
  )
}

export default GiftRules
